import type { Phrases, TranslationExclusionValue } from '../../types';
import { checkEmailNode } from '../utils/check-email-node';
import { checkExcludedNode } from '../utils/check-excluded-node';
import { getAllShadowRoots } from '../utils/get-all-shadow-roots';

const IGNORED_TAGS = ['SCRIPT', 'STYLE', 'IMG', 'ICON', 'VIDEO', 'NOSCRIPT'];

export function textFinder(
  element: Element | Node,
  translationExclusions?: TranslationExclusionValue[]
): { textNodes: Node[]; textPhrases: Phrases } {
  const allNodes: Node[] = [];
  const allPhrases: Phrases = [];

  const collectTranslatableTextNodes = (contextElement: Element | Node) => {
    const treeWalker = document.createTreeWalker(
      contextElement,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode(node) {
          const isNodeEmail = checkEmailNode(node.nodeValue);
          const isNodeExcluded = checkExcludedNode(node, translationExclusions);

          const isMatchingNode =
            !!node.nodeValue &&
            !isNodeEmail &&
            !isNodeExcluded &&
            node.nodeValue.replace(/\s+|\d+/g, '') !== '' &&
            (!node.parentNode ||
              !IGNORED_TAGS.includes(node.parentNode.nodeName));

          return isMatchingNode
            ? NodeFilter.FILTER_ACCEPT
            : NodeFilter.FILTER_SKIP;
        }
      }
    );

    // ищем все текстовые узлы и фразы
    while (treeWalker.nextNode()) {
      const { currentNode } = treeWalker;

      if (!currentNode.nodeValue) continue;

      allNodes.push(currentNode);
      allPhrases.push(currentNode.nodeValue);
    }
  };

  collectTranslatableTextNodes(element);

  if (element instanceof Element) {
    const shadowRoots = getAllShadowRoots(element);

    shadowRoots.forEach(collectTranslatableTextNodes);
  }

  return { textNodes: allNodes, textPhrases: allPhrases };
}
